const addToHomescreen = {
  namespaced: true,
  state: {
    show: false,
    overlay: false
  },
  mutations: {
    showOverlay(state) {
      state.overlay = true
    },
    hideOverlay(state) {
      state.overlay = false
    }
  },
  actions: {
    showOverlay(context) {
      context.commit('showOverlay')
    },
    hideOverlay(context) {
      context.commit('hideOverlay')
    }
  }
}

export default addToHomescreen